import React from 'react'
import AboutBanner from '../components/AboutUs/AboutBanner'
import AboutCompany from '../components/AboutUs/AboutCompany'
import OurTeam from '../components/OurTeam'
import Createinsights from "../components/Createinsights";
import Testimonials from '../components/AboutUs/Testimonials';
import Footer from "../components/Footer";


export default function AboutUs() {
  return (
    <>
    <AboutBanner/>
    <AboutCompany/>
    <OurTeam/>
    <Createinsights/>
    <Testimonials/>
    <Footer/>
    
    </>
  )
}
